import * as Sentry from "@sentry/react";
import posthog from "posthog-js";

posthog.init(import.meta.env.REACT_APP_PUBLIC_POSTHOG_KEY, {
    api_host: import.meta.env.REACT_APP_PUBLIC_POSTHOG_HOST,
});

export { posthog };

Sentry.init({
    dsn: "https://4a201a998cd2f472697d6069ec4f9008@o4508766569824256.ingest.de.sentry.io/4511353379160144",
    release: import.meta.env.ALBERTINE_VERSION,
    environment: import.meta.env.ALBERTINE_ENV,
    integrations: [
        // lmt mounts a single catch-all route, so URL-based browser tracing is
        // enough; the React Router v5 integration would only add value with
        // parameterized route paths.
        Sentry.browserTracingIntegration(),
        posthog.sentryIntegration({
            organization: "albertine",
            projectId: 4511353379160144,
        }),
    ],
    tracesSampleRate: import.meta.env.ALBERTINE_ENV === "prod" ? 0.2 : 1.0,
});
